module.exports = __webpack_public_path__ + "static/img/case5.9785c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/case5.png
// module id = V+NQ
// module chunks = 1